import { Component, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { UploadAssetService } from '../../../services/upload-asset.service';

@Component({
  selector: 'dal-assetuploadpreview',
  templateUrl: './assetuploadpreview.component.html',
  styleUrl: './assetuploadpreview.component.scss',
})

export class AssetUploadPreviewComponent implements OnInit {
  selectedAsset: number = 0;

  constructor(
    public uploadAssetService: UploadAssetService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.uploadAssetService.formInitialization()
  }

  get fileControls() {
    return (this.uploadAssetService.assetPreviewForm.get('files') as FormArray)?.controls || [];
  }

  deleteImage(index: number) {
    if (this.fileControls && this.fileControls.length > index) {
      this.uploadAssetService.removeFile(index);
    }
    if (this.fileControls.length === 0) {
      this.router.navigate(['/']);
    }
  }

  onCsvUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        const csvContent = reader.result as string;
        this.parseCsvAndApplyTitles(csvContent);
      };
      reader.readAsText(file);
    }
  }

  private parseCsvAndApplyTitles(csvContent: string): void {
    const rows = csvContent.split('\n').map(row => row.trim());
    const headers = rows[0].split(',').map(header => header.trim());
    const fileNameIndex = headers.indexOf('fileName');
    const titleIndex = headers.indexOf('title');

    if (fileNameIndex === -1 || titleIndex === -1) {
      console.error('CSV must contain "fileName" and "title" columns.');
      return;
    }

    const data = rows.slice(1).map(row => {
      const columns = row.split(',').map(col => col.trim());
      return {
        fileName: columns[fileNameIndex],
        title: columns[titleIndex],
      };
    });

    const filesFormArray = this.uploadAssetService.assetPreviewForm.get('files') as FormArray;

    data.forEach(({ fileName, title }) => {
      // Update the metadata in assetPayload
      const matchingAsset = this.uploadAssetService.assetPayload.find(asset => asset.file.name === fileName);
      if (matchingAsset) {
        matchingAsset.metadata = {
          ...matchingAsset.metadata,
          title: title, // Update the title in metadata
        };
      }
    });

    this.uploadAssetService.formInitialization()
  }


}
